<app-fbm-skudetails [skuList]="skuList"></app-fbm-skudetails>